import { useQuery } from '@tanstack/react-query';
import { learnerApiJson } from '@/lib/learner-api';
import { useLearnerAuth } from '@/providers/LearnerAuth';

export type StreakSnapshot = {
  current_streak: number;
  longest_streak: number;
  qualified_today: boolean;
  freezes_remaining?: number;
};

export type StreakLeaderboardEntry = {
  rank: number;
  display_name?: string | null;
  nickname?: string | null;
  streak: number;
};

export function useStreaks() {
  const auth = useLearnerAuth();
  const streak = useQuery({
    queryKey: ['learner-streak'],
    queryFn: () => learnerApiJson<StreakSnapshot>(auth?.getToken ?? null, '/v1/streaks'),
    staleTime: 30_000,
    retry: 1,
  });
  const leaderboard = useQuery({
    queryKey: ['learner-streak-leaderboard'],
    queryFn: () =>
      learnerApiJson<{ by_current?: StreakLeaderboardEntry[] }>(
        auth?.getToken ?? null,
        '/v1/streaks/leaderboard?limit=5',
      ),
    staleTime: 60_000,
    retry: 1,
  });
  return {
    streak: streak.data ?? null,
    leaderboard: leaderboard.data?.by_current ?? [],
    refresh: () => Promise.all([streak.refetch(), leaderboard.refetch()]),
  };
}
